import script from "./NewRecordingConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRecordingConfirmModal.vue?vue&type=script&setup=true&lang=js"

import "./NewRecordingConfirmModal.vue?vue&type=style&index=0&id=418cb050&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418cb050"]])

export default __exports__